export default "__VITE_ASSET__2ccd23c6__"